import React, { useEffect, useState } from 'react'
import { Dropdown, Menu } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { es_dateFormat } from 'constants/date'
import { IFilterOption, IFilterRow } from 'interfaces//filterProps'
import FilterRow from '../commons/filter-row'
import styles from './index.module.scss'

interface ISimpleFilter {
  translations: any
  selectedData: IFilterRow[]
  columnsData: IFilterOption[]
  onChange: any
  onDelete: any
  generalCondition: string
  onGeneralConditionChange: any
  dateFormat?: string
}

const SimpleFilter: React.FC<ISimpleFilter> = ({ selectedData, columnsData, translations, onChange, onDelete, generalCondition, onGeneralConditionChange, dateFormat = es_dateFormat }) => {
  const [columns, setColumns] = useState([] as any[])

  const handleChange = (index: number, selectedData: any, selectedDataChild?: any) => {
    const { input, type, values, group, async, additionalFields } = selectedData
    if (selectedDataChild && selectedData) {
      onChange({
        index,
        input,
        type,
        values,
        async,
        additionalFields,
        group: group || 0,
        childrensGroup: {
          index: selectedDataChild.index,
          input: selectedDataChild.input,
          type: selectedDataChild.type,
          values: selectedDataChild.values,
          group: selectedDataChild.group || 0,
        },
      })
    } else {
      onChange({ index, input, type, values, group: group || 0, async, additionalFields })
    }
  }

  useEffect(() => {
    const list = document.getElementById('simpleFilters-filterContainer')
    if (list) list.style.marginRight = selectedData.length > 9 ? '-20px' : '-5px'
  }, [selectedData])

  useEffect(() => {
    setColumns(columnsData)
  }, [columnsData])

  const filterChildrens = (data: any, compare: any) => data.find(({ type }: any) => type === 'group')?.list?.find(({ value }: any) => value === compare)
  return (
    <div className={`${styles.container} rankmiTable-filters-simpleFilter`}>
      <div className={styles.condition}>
        {translations.simpleFilter.condition}
        <Dropdown
          className="rankmiTable-filters-simpleFilter-generalCondition"
          overlay={
            <Menu>
              <Menu.Item>
                <a className={`${styles.generalConditionSelectorOptions} rankmiTable-filters-simpleFilter-generalCondition-options`} onClick={() => onGeneralConditionChange('and')}>
                  <div className={styles.title}>{translations.simpleFilter.allConditions.title}</div>
                  <div className={styles.description}>{translations.simpleFilter.allConditions.description}</div>
                </a>
              </Menu.Item>
              <Menu.Item>
                <a className={`${styles.generalConditionSelectorOptions} rankmiTable-filters-simpleFilter-generalCondition-options`} onClick={() => onGeneralConditionChange('or')}>
                  <div className={styles.title}>{translations.simpleFilter.anyCondition.title}</div>
                  <div className={styles.description}>{translations.simpleFilter.anyCondition.description}</div>
                </a>
              </Menu.Item>
            </Menu>
          }
        >
          <a className={styles.generalConditionSelector} onClick={(e) => e.preventDefault()}>
            {translations.simpleFilter[generalCondition === 'and' ? 'allConditions' : 'anyCondition'].title} <FontAwesomeIcon icon={faCaretDown} />
          </a>
        </Dropdown>
      </div>
      <div className={`${styles.filterContainer} rankmiTable-filters-simpleFilter-filtersContainer`} id="simpleFilters-filterContainer">
        {columns.length > 0 &&
          selectedData.map((item: IFilterRow, index) => {
            return (
              <div key={index}>
                <FilterRow
                  closeable={!!item.input || !!index}
                  compareTo={item.compareTo}
                  dateFormat={dateFormat}
                  input={item.input}
                  inputOptions={columns}
                  key={`filter-row-${index}`}
                  operator={item.operator}
                  selectedData={item}
                  translations={translations}
                  onChange={(selectedData: IFilterRow) => handleChange(index, { ...selectedData, group: item.group || 0, async: item.async, additionalFields: item.additionalFields })}
                  onDelete={() => onDelete(index)}
                />
                {item.type === 'group' ? (
                  <FilterRow
                    styleGroup
                    closeable={false}
                    compareTo={item.childrensGroup?.compareTo}
                    dateFormat={item.childrensGroup?.dateFormat}
                    disabled={!item.compareTo}
                    input={item.childrensGroup?.input}
                    inputOptions={item.compareTo ? filterChildrens(columns, item.compareTo).childrensGroup : []}
                    key={`filter-row-child-${index}`}
                    operator={item.childrensGroup?.operator}
                    selectedData={item}
                    translations={translations}
                    onChange={(selectedDataChild: IFilterRow) => {
                      handleChange(
                        index,
                        {
                          index,
                          input: item.input,
                          type: item.type,
                          values: { label: filterChildrens(columns, item.compareTo).label || '', value: item.compareTo },
                          group: item.group || 0,
                          async: item.async,
                          additionalFields: item.additionalFields,
                        },
                        { ...selectedDataChild }
                      )
                    }}
                  />
                ) : null}
              </div>
            )
          })}
        {!selectedData.length && (
          <FilterRow
            closeable={false}
            inputOptions={columnsData}
            selectedData={selectedData}
            translations={translations}
            onChange={(selectedData: IFilterRow) => handleChange(0, { ...selectedData, group: 0 })}
          />
        )}
      </div>
    </div>
  )
}

export default SimpleFilter
